import {Box, Skeleton, Typography} from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import ScheduleIcon from '@mui/icons-material/Schedule';
import type {ReactNode} from 'react';
import React from 'react';

export interface TripPanelExtra {
    icon: ReactNode;     // z. B. <LocalShippingIcon /> oder <UTurnLeftIcon />
    label: string;       // "Zustellung" | "Abholung"
    /* Optional: without address data the line is omitted, not left blank. */
    address?: string;
    time?: string;
}

export interface TripPanelProps {
    kicker: string;
    station?: string;
    date?: string;
    time?: string;
    loading?: boolean;
    extra?: TripPanelExtra | null;
}

export function TripPanel({
                              kicker, station, date, time, loading, extra,
                          }: TripPanelProps) {
    return (
        <Box sx={{flex: 1, border: 1, borderColor: 'divider', borderRadius: 2, p: 1.5}}>
            <Typography
                sx={{
                    fontSize: 11, fontWeight: 600, color: 'rgba(0,0,0,.5)',
                    textTransform: 'uppercase', letterSpacing: '.05em', mb: 1
                }}
            >
                {kicker}
            </Typography>

            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 1}}>
                <PlaceIcon sx={{fontSize: 17, color: 'error.dark'}}/>
                {loading ? (
                    <Skeleton variant="text" width={96} sx={{fontSize: 14}}/>
                ) : (
                    <>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}>{station}</Typography>
                    </>
                )}
            </Box>

            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <ScheduleIcon sx={{fontSize: 16, color: 'action.active'}}/>
                {loading ? (
                    <Skeleton variant="text" width={120} sx={{fontSize: 14}}/>
                ) : (
                    <Typography sx={{fontSize: 14, fontVariantNumeric: 'tabular-nums'}}>
                        {date}&nbsp;&nbsp;<Box component="span" sx={{fontWeight: 600}}>{time}</Box>
                    </Typography>
                )}
            </Box>

            {/* optionale Liefer-/Abhol-Adresszeile */}
            {!loading && extra && (
                <Box sx={{mt: 1.25, pt: 1.25, borderTop: '1px dashed rgba(0,0,0,.14)'}}>
                    <Box sx={{
                        display: 'flex', alignItems: 'center', gap: 0.875, mb: 0.375,
                        color: 'info.dark', '& svg': {fontSize: 15}
                    }}>
                        {extra.icon}
                        <Typography sx={{
                            fontSize: 11, fontWeight: 600, color: 'info.dark',
                            textTransform: 'uppercase', letterSpacing: '.04em'
                        }}>
                            {extra.label}
                        </Typography>
                    </Box>
                    {extra.address && (
                        <Typography sx={{fontSize: 13, color: 'text.primary', pl: 2.75, lineHeight: 1.45}}>
                            {extra.address}
                        </Typography>
                    )}
                    {extra.time && (
                        <Typography sx={{
                            fontSize: 12.5, color: 'text.secondary', pl: 2.75,
                            fontVariantNumeric: 'tabular-nums'
                        }}>
                            {extra.time}
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
}